// Module
var code = `<div class="callout-content">
  <header>
      <h3 class="callout-headline">{{headline}}</h3>
      <div class="callout-subheadline">{{subheadline}}</div>
      <div class="callout-text">{{text}}</div>

  </header>
  <div class="links">
    {{#links}}

    <a
      data-channel="ROUTE"
      data-page-id="compare"
      data-event-prevent-default="true"
      href="{{href}}"
      >{{text}}</a
    >

    {{/links}} {{#link}}

    <a target="_blank" href="{{href}}">{{text}}</a>

    {{/link}}
  </div>
</div>
`;
// Exports
module.exports = code;